import { Breakpoints, BreakpointWrapper, Container, ContainerGutter, DecorativeImage, Layout, LayoutConfigurations } from '@volkswagen-onehub/components-core';
import React, { useContext, useEffect, useState } from 'react';
import { LayerManagerV2 } from '@volkswagen-onehub/layer-manager';
import { useTranslation } from 'react-i18next';
import { useLocation } from 'react-router-dom';
import styled from 'styled-components';
import VinInput from '../../components/VinInput/VinInput';
import './StartPage.scss';
import WhatIsAVinModal, { WhatIsAVinModalProps } from '../../components/WhatIsAVinModal/WhatIsAVinModal';
import { openContentLayer } from '../../service/LayerService/LayerService';
import { FeatureServicesContext } from '../../use-feature-services';
import BrokenShareLinkModal from '../../components/BrokenShareLinkModal/BrokenShareLinkModal';

const ImageContainer = styled.div`
	width: 100%;
	height: 100%;
	overflow: hidden;
`;

const VinInputColumn = styled.div`
	display: flex;
	flex-direction: column;
	justify-content: center;
	height: 100%;
`;

const startPageAppearance = {
	[Breakpoints.b1600]: [
		{ name: 'a', columns: 15 },
		{ name: '.', columns: 2 },
		{ name: 'b', columns: 6 },
		{ name: '.', columns: 1 },
	],
	[Breakpoints.b960]: [
		{ name: 'a', columns: 14 },
		{ name: '.', columns: 2 },
		{ name: 'b', columns: 6 },
		{ name: '.', columns: 2 },
	],
	[Breakpoints.b560]: [
		{ name: 'a', columns: 0 },
		{ name: '.', columns: 4 },
		{ name: 'b', columns: 16 },
		{ name: '.', columns: 4 },
	],
	[Breakpoints.default]: [
		{ name: 'a', columns: 0 },
		{ name: '.', columns: 2 },
		{ name: 'b', columns: 20 },
		{ name: '.', columns: 2 },
	],
};

function StartPage() {
	const featureServices = useContext(FeatureServicesContext);
	const location = useLocation();

	window.history.replaceState({}, document.title);
	const { t } = useTranslation('ns1', { useSuspense: false });

	const [brokenShareLink] = useState((location.state as { brokenLink: boolean })?.brokenLink ?? false);
	const [isShareLinkErrorActive, setShareLinkErrorActive] = useState(false);

	let baseUrl = '';
	let imageUrl: string | undefined;
	let layerManager = {} as LayerManagerV2;
	if (featureServices && featureServices['fa-content-service']) {
		baseUrl = featureServices['fa-content-service']!.content.baseAssetUrl;
		imageUrl = featureServices['fa-content-service']!.content.startPageImage;
		layerManager = featureServices['layer-manager'];
	}

	const hasValidImageUrl = Boolean(imageUrl?.trim());

	if (featureServices && featureServices['breadcrumb-service']) {
		featureServices['breadcrumb-service'].set([]);
	}

	let trackingService: any;
	if (featureServices && featureServices.tracking) {
		trackingService = featureServices.tracking;
	}

	const vinCheckTracking = () => {
		trackingService.track('VWBasic_LayerClose_Click', {
			eventInfo: {
				eventAction: 'VWBasic_LayerClose_Click',
				pageId: window.location.href,
				pageName: 'Start Page',
				contentId: 'startPage.whatIsAVin.close',
				sectionName: 'whatIsAVin',
				brand: 'passenger',
			},
			user: {
				browserResolutionHeight: window.innerHeight,
				browserResolutionWidth: window.innerWidth,
				browserResolutionOrientation: window.innerHeight >= window.innerWidth ? 'v' : 'h',
			},
			personalization: {
				personalizable: false,
			},
		});
	};

	useEffect(() => {
		window.sessionStorage.clear();
	});

	return hasValidImageUrl ? (
		<Layout appearance={startPageAppearance}>
			<BreakpointWrapper min={Breakpoints.b960}>
				<ImageContainer>
					<DecorativeImage src={imageUrl} objectFit="cover" style={{ width: '100%', height: '100%' }} />
				</ImageContainer>
			</BreakpointWrapper>
			<VinInputColumn id="vin-input">
				<Container padding={ContainerGutter.static100} stretchContent>
					<VinInput
						trackingService={trackingService}
						setVinOverlayActive={() => {
							openContentLayer<WhatIsAVinModalProps>(
								layerManager,
								WhatIsAVinModal,
								{
									baseUrl,
									trackingService,
									t,
								},
								{
									userCloseable: false,
									onClose: vinCheckTracking,
								},
							);
						}}
					/>
				</Container>
				{brokenShareLink
					? [!isShareLinkErrorActive && <BrokenShareLinkModal t={t} toggleVisibility={() => setShareLinkErrorActive(!isShareLinkErrorActive)} />]
					: undefined}
			</VinInputColumn>
		</Layout>
	) : (
		<Layout appearance={LayoutConfigurations.full}>
			<div id="vin-input">
				<Container padding={ContainerGutter.static100} stretchContent>
					<VinInput
						trackingService={trackingService}
						setVinOverlayActive={() => {
							openContentLayer<WhatIsAVinModalProps>(
								layerManager,
								WhatIsAVinModal,
								{
									baseUrl,
									trackingService,
									t,
								},
								{
									userCloseable: false,
									onClose: vinCheckTracking,
								},
							);
						}}
					/>
				</Container>
				{brokenShareLink
					? [!isShareLinkErrorActive && <BrokenShareLinkModal t={t} toggleVisibility={() => setShareLinkErrorActive(!isShareLinkErrorActive)} />]
					: undefined}
			</div>
		</Layout>
	);
}

export default StartPage;
